import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { doCreateUserWithEmailAndPassword, doSignInWithGoogle } from "../firebase/auth";
import { FaEnvelope, FaEye, FaEyeSlash, FaLock, FaTimes } from "react-icons/fa";

const Signup = ({ onClose }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const toggleShowPassword = () => setShowPassword(!showPassword);
    const toggleShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

    const handleRegister = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        try {
            await doCreateUserWithEmailAndPassword(email, password);
            alert("User registered successfully!");
            navigate("/account");
        } catch (error) {
            setError(error.message);
        }
    };

    const onGoogleSignIn = async (e) => {
        e.preventDefault();
        try {
            await doSignInWithGoogle();
            alert("Signup successful! You are now logged in.");
            navigate("/account");
        } catch (error) {
            setError("Error signing in with Google");
            console.error(error);
        }
    };

    return (
        <div className="absolute bg-gray-200 dark:bg-gray-900 bg-opacity-50 text-gray-400 w-full h-full top-0 p-4 lg:z-50">
            <div className="flex justify-end text-light1 ">
                <div
                    onClick={onClose}
                    className="w-12 h-12 hover:text-primary rounded-full bg-light1 dark:bg-dark2 flex justify-center items-center text-gray-400"
                >
                    <FaTimes />
                </div>
            </div>
            <div className="flex flex-col justify-center items-center border-light1 dark:border-dark2 bg-light2 dark:bg-dark1 border-2 mx-auto my-16 w-3/4 md:w-1/2 lg:w-1/4 rounded-lg p-4 hover:border-primary dark:hover:border-primary">
                <form onSubmit={handleRegister}>
                    <h2 className="text-primary font-bold text-lg">Signup</h2>
                    <hr className="m-2 border-gray-400" />
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <div className="m-2 mt-6 bg-light1 dark:bg-dark2 rounded-lg flex w-full items-center p-2">
                        <FaEnvelope className="mx-2" />
                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="outline-none border-none w-3/4 mx-2 bg-light1 dark:bg-dark2"
                        />
                    </div>
                    <div className="m-2 mt-6 bg-light1 dark:bg-dark2 rounded-lg flex w-full items-center p-2">
                        <FaLock className="mx-2" />
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="outline-none border-none w-3/4 mx-2 bg-light1 dark:bg-dark2"
                        />
                        <div onClick={toggleShowPassword}>
                            {showPassword ? <FaEyeSlash className="mx-2" /> : <FaEye className="mx-2" />}
                        </div>
                    </div>
                    <div className="m-2 mt-6 bg-light1 dark:bg-dark2 rounded-lg flex w-full items-center p-2">
                        <FaLock className="mx-2" />
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="outline-none border-none w-3/4 mx-2 bg-light1 dark:bg-dark2"
                        />
                        <div onClick={toggleShowConfirmPassword}>
                            {showConfirmPassword ? <FaEyeSlash className="mx-2" /> : <FaEye className="mx-2" />}
                        </div>
                    </div>
                    <button type="submit" className="btn m-2 w-full">
                        Signup
                    </button>
                    <div className="m-2 flex items-center justify-around">
                        <hr className="w-1/3 border-gray-400" /> Or <hr className="w-1/3 border-gray-400" />
                    </div>
                    <button onClick={onGoogleSignIn} className="w-full m-2 hover:border-primary font-medium text-gray-400 border-b hover:text-primary bg-light1 dark:bg-dark2 rounded-lg p-2">
                        Continue with Google
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Signup;




















// import React, { useState } from "react";
// import { useNavigate } from 'react-router-dom';
// import { doCreateUserWithEmailAndPassword, doSignInWithGoogle } from "../firebase/auth";
// import { FaEnvelope, FaEye, FaEyeSlash, FaLock, FaTimes, FaUser } from "react-icons/fa";


//   const Signup = ({onClose}) => {
//   const [username, setUsername] = useState("");
//   const [email, setEmail] = useState(""); 
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [error, setError] = useState("");

    
//   const navigate = useNavigate();

//   const toggleShowPassword = ()=>{
//     setShowPassword(!showPassword);
//   }
//   const toggleShowConfirmPassword = ()=>{
//     setShowConfirmPassword(!showConfirmPassword);
//   }

//   // google signup/signin function
//   const [isSigningIn, setIsSigningIn]=useState(false);

//   const handleRegister = async (e) => {
//     e.preventDefault();
//     if(password != confirmPassword) {
//     setError('password does not match')
//    return;
//     }
//     try {
//       await doCreateUserWithEmailAndPassword(email, password);
//       alert("User registered successfully!");
//     } catch (error) {
//       setError(error.message);
//     }
//   };

//   // google signup/signin function
//   const onGoogleSignIn = (e)=> {
//     e.preventDefault();
//     if(!isSigningIn){
//       setIsSigningIn(true);
//        doSignInWithGoogle(email, password).catch(err => {
//         setIsSigningIn(false);
//       });
//       navigate('/account');
//       alert("signup successful, you currently loggedin");
//     }
//   }

//   return (
//     <div className="absolute bg-gray-200 dark:bg-gray-900 bg-opacity-50 text-gray-400 w-full h-full top-0 p-4 lg:z-50">
//       <div className="flex justify-end text-light1 ">
//         <div onClick={onClose} className="w-12 h-12 hover:text-primary rounded-full bg-light1 dark:bg-dark2 flex justify-center items-center text-gray-400">
//           <FaTimes/>
//         </div> 
//       </div>
//       <div className="flex flex-col justify-center items-center border-light1 dark:border-dark2 bg-light2 dark:bg-dark1 border-2 mx-auto my-16 w-3/4 md:w-1/2 lg:w-1/4 rounded-lg p-4 hover:border-primary dark:hover:border-primary">
//         <form onSubmit={handleRegister}>
//         <h2 className="text-primary font-bold text-lg">Signup</h2>
//         <hr className="m-2 border-gray-400"/>
//         {error && <p style={{ color: "red" }}>{error}</p>}
//         {/* <div className="m-2 mt-6 bg-dark2 rounded-lg flex w-full items-center p-2 ">
//           <FaUser className="mx-2"/>
//           <input
//             className="outline-none border-none w-3/4 mx-2 bg-dark2"
//             type="text"
//             placeholder="Username"
//             value={email}
//             onChange={(e) => setUsername(e.target.value)}
//           /> 
//         </div >*/}
//         <div className="m-2 mt-6 bg-light1 dark:bg-dark2 rounded-lg flex  w-full items-center p-2">
//           <FaEnvelope className="mx-2"/>
//           <input
//             className="outline-none border-none w-3/4 mx-2 bg-light1 dark:bg-dark2"
//             type="email"
//             placeholder="Email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />
//         </div >
//         <div className="m-2 mt-6 bg-light1 dark:bg-dark2 rounded-lg flex  w-full items-center p-2">
//           <FaLock className="mx-2"/>
//           <input
//             className="outline-none border-none w-3/4 mx-2 bg-light1 dark:bg-dark2"
//             type={showPassword? "text":"password"}
//             placeholder="Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//           />
//           <div onClick={toggleShowPassword}>
//             {showPassword? <FaEyeSlash className="mx-2"/>:<FaEye className="mx-2"/> }
//           </div>
//         </div>
//         <div className="m-2 mt-6 bg-light1 dark:bg-dark2 rounded-lg flex  w-full items-center p-2">
//           <FaLock className="mx-2"/>
//           <input
//             className="outline-none border-none w-3/4 mx-2 bg-light1 dark:bg-dark2"
//             type={showConfirmPassword? "text":"password"}
//             placeholder="Confirm Password"
//             value={confirmPassword}
//             onChange={(e) => {setConfirmPassword(e.target.value) }}
//           />
//           <div onClick={toggleShowConfirmPassword}>
//             {showConfirmPassword? <FaEyeSlash className="mx-2"/> :<FaEye className="mx-2"/> }
//           </div>
//         </div>
//         <button type="submit" className="btn m-2 w-full">{isSigningIn? 'Signing up ...':'Signup'}</button>
//         <div className="m-2 flex items-center justify-around"> <hr className="w-1/3 border-gray-400"/> Or <hr  className="w-1/3 border-gray-400"/></div>
//         <button onClick={(e)=> onGoogleSignIn(e)} type="submit" className=" w-full m-2 hover:border-primary border-b hover:text-primary  bg-light1 dark:bg-dark2 rounded-lg p-2">Continue with Google</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Signup;
